module.exports = __webpack_public_path__ + "static/img/32022.d41fb4b5.jpg";